/**
 * External dependencies
 */
import React from 'react';
import { Provider } from 'react-redux';
import { noop } from 'lodash';
import page from 'page';
import { TowerProvider } from '@towersystems/towersystems-design-system';


/**
 * Internal dependencies
 */
import { setSection as setSectionAction } from 'state/ui/actions';
import { isUserLoggedIn } from 'state/current-user/selectors';
import Layout from 'layout';
import LoggedOutLayout from 'layout/logged-out';
export { render, hydrate, redirectLoggedIn } from './utils';

export function setSection(section) {
    return (context, next = noop) => {
        context.store.dispatch(setSectionAction(section));
    };
}

export function makeLayoutMiddleware(LayoutComponent) {

    return (context, next) => {
        const { store, primary, secondary, topbar } = context;
        context.layout = (
            <TowerProvider>
                <LayoutComponent
                	topbar={topbar}
                    store={store}
                    primary={primary}
                    secondary={secondary}
                    redirectUri={context.originalUrl}
                />
            </TowerProvider>
        );
        next();
    };
}

export const ReduxWrappedLoggedOutLayout = ({ store, topbar, primary, secondary, redirectUri }) => {
   
    return (
        <Provider store={store}>
            <LoggedOutLayout primary={primary} secondary={secondary} topbar={topbar}/>
        </Provider>
    );
};


export const makeLoggedOutLayout = makeLayoutMiddleware(ReduxWrappedLoggedOutLayout);


export const ReduxWrappedLayout = ({ store, primary, topbar, secondary, redirectUri }) => {
    const state = store.getState();
    const userLoggedIn = isUserLoggedIn(state);
       
  
    const layout = userLoggedIn ? (
        <Layout primary={primary} secondary={secondary} topbar={topbar} />
    ) : (
            <LoggedOutLayout primary={primary} secondary={secondary} topbar={topbar}/>
        );
   
    //const layout = <Layout primary={primary} secondary={secondary} topbar={topbar} />
 
    return <Provider store={store}>{layout}</Provider>;
};

export const makeLayout = makeLayoutMiddleware(ReduxWrappedLayout);

export function clientRouter(route, ...middlewares) {
    page(route, ...middlewares);
}
